import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Activites from './components/activites/activites';
import Athletisme from './components/activites/details/athletisme/athletisme';
import CardioBoxing from './components/activites/details/cardioboxing/cardioboxing';
import CrossTraining from './components/activites/details/crosstraining/crosstraining';
import Fitdance from './components/activites/details/fitdance/fitdance';
import Pilates from './components/activites/details/pilates/pilates';
import QuiSuisJe from './components/quisuisje/quisuisje';
import Stage from './components/stage/stage';
import Contact  from './components/contact/contact';
import './App.css';
import SmoothScroll from "smooth-scroll";
import CGV from "./components/footer/cgv";
import MentionsLegales from "./components/footer/mentions_legales";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {

  return (
    <div>
          <BrowserRouter>
      <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/mes_activites" element={<Activites />} />
      <Route path="/athletisme" element={<Athletisme />} />
      <Route path="/cardio_boxing" element={<CardioBoxing />} />
      <Route path="/cross_training" element={<CrossTraining />} />
      <Route path="/fitdance" element={<Fitdance />} />
      <Route path="/pilates" element={<Pilates />} />
      <Route path="/qui_suis_je" element={<QuiSuisJe />} />
      <Route path="/stage" element={<Stage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/CGV" element={<CGV />} />
      <Route path="/mentions_legales" element={<MentionsLegales />} />

      </Routes>
      </BrowserRouter>


      </div>
  );
}

export default App;
